import { I18n } from "react-redux-i18n";

export function isUserVerified(userOrItem) {
  if (!userOrItem) {
    return false;
  }

  return Boolean(
    userOrItem.verified ||
      userOrItem.Verified ||
      userOrItem.isVerified
  );
}
